import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundaryWrapper from './template/ErrorBoundary';
import Routes from "./routes";
import AppLayout from "./template/Layout";
import './App.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <AppLayout>
            <Routes />
          </AppLayout>
        </Suspense>
      </BrowserRouter>
      <ToastContainer
        toastStyle={{ fontSize: "1.48vh", padding: "0.74vh" }}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ErrorBoundaryWrapper(App);
